export default "__VITE_ASSET__72f0aa3a__"